export const SET_TYPE_FORFAIT_TRANSPORT = 'SET_TYPE_FORFAIT_TRANSPORT'
export const INIT_TYPE_FORFAIT_TRANSPORT = 'INIT_TYPE_FORFAIT_TRANSPORT'
